import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'classnames';
import { withStyles } from "@material-ui/core/styles";

const styles = {
	cell: {
		border: `1px solid #bbb`,
		overflowX: 'hidden',
		height: 'auto',
		position : 'relative',
		padding : 0,
	},
};

function Cell(props) {
	const { className, classes, children, numberOfDays, isOdd, colSpan, isTableHeader, isDriverRoom} = props;

	let style = {};
	if (numberOfDays) {
		//- minus one because of the left column
		style = { width: 100 / (numberOfDays + 1) + '%' };
	}

	if (isOdd) {
		style.backgroundColor = '#f2f2f2';
	}

	if (isTableHeader) {
		style.position = 'sticky';
		style.top = 0;
		style.zIndex = 101;
		style.boxShadow = '0 2px 2px -1px rgba(0, 0, 0, 0.4)';
		return (
			<th className={clsx(classes.cell, className)} style={style} colSpan={colSpan}>
				{children}
			</th>
		);
	} else {
		if (isDriverRoom) {
			style.border = `1px solid #333`;
		}

		return (
			<td className={clsx(classes.cell, className)} style={style} colSpan={colSpan}>
				{children}
			</td>
		);
	}

}
Cell.propTypes = {
	numberOfDays: PropTypes.number,
	isTableHeader : PropTypes.bool,
};
Cell.defaultProps = {};
export default memo(withStyles(styles)(Cell));